<main class="auth">
	<div class="form">
		<div class="logo"></div>
		<h4>Log into your account</h4>

		  <login-form (onNavigateTo)="navigateTo($event)" (onLogin)="login($event)"></login-form>

		</div>	
</main>
